export const downloadFileFromURL = async (url: string, filename: string) => {
  const linkElement = document.createElement("a");
  linkElement.setAttribute("href", url);
  linkElement.setAttribute("download", filename);
  linkElement.setAttribute("target", "_blank");
  linkElement.click();
};
